import { AnnotationTemplateWithoutContents } from '@paragon/contract-library';

export const isSystemTemplate = (template: AnnotationTemplateWithoutContents) =>
  template.userEmail === null && template.organization === null;

export const isOrganizationTemplate = (template: AnnotationTemplateWithoutContents) =>
  template.userEmail == null && template.organization !== null;

export const isUserTemplate = (template: AnnotationTemplateWithoutContents) => template.userEmail !== null;

export const getTemplateDisplayName = (template: AnnotationTemplateWithoutContents) => {
  if (isSystemTemplate(template)) return `${template.name} (System)`;
  if (isOrganizationTemplate(template)) return `${template.name} (Organization)`;
  return template.name;
};

export interface TrussDesignDrawingTemplates {
  readonly trussDesignDrawingTemplates: readonly AnnotationTemplateWithoutContents[] | null;
  readonly trussDesignDrawingOverflowTemplates: readonly AnnotationTemplateWithoutContents[] | null;
  readonly repairTrussDesignDrawingTemplates: readonly AnnotationTemplateWithoutContents[] | null;
}

export const groupTrussDesignDrawingTemplates = (
  templates: readonly AnnotationTemplateWithoutContents[],
): TrussDesignDrawingTemplates => ({
  trussDesignDrawingTemplates: templates.filter((template) => template.templateType === 'TrussDesignDrawing'),
  trussDesignDrawingOverflowTemplates: templates.filter(
    (template) => template.templateType === 'TrussDesignDrawingOverflow',
  ),
  repairTrussDesignDrawingTemplates: templates.filter(
    (template) => template.templateType === 'RepairTrussDesignDrawing',
  ),
});

const getDefaultTemplateId = (templates: readonly AnnotationTemplateWithoutContents[] | null) =>
  (templates?.find(isSystemTemplate) ?? templates?.[0])?.id ?? null;

export const getDefaultTrussDesignDrawingTemplateIds = (
  templates: TrussDesignDrawingTemplates,
  useRepairTemplate: boolean,
) => ({
  templateId: getDefaultTemplateId(
    useRepairTemplate ? templates.repairTrussDesignDrawingTemplates : templates.trussDesignDrawingTemplates,
  ),
  overflowTemplateId: getDefaultTemplateId(templates.trussDesignDrawingOverflowTemplates),
});

const hasChoices = (templates: readonly AnnotationTemplateWithoutContents[] | null) => (templates?.length ?? 0) > 1;

export const hasTrussDesignDrawingTemplateChoices = (
  templates: TrussDesignDrawingTemplates,
  useRepairTemplate: boolean,
) =>
  useRepairTemplate
    ? hasChoices(templates.repairTrussDesignDrawingTemplates)
    : hasChoices(templates.trussDesignDrawingTemplates) || hasChoices(templates.trussDesignDrawingOverflowTemplates);
